// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { ActionCreatorsMapObject, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';

import { LayoutSkin } from 'wdna-components/lib/layout/types';
import * as LayoutActions from 'wdna-components/lib/layout/actions';

import { config } from '../../../config/config';

interface Props extends Partial<RouteComponentProps> {
  smartSkin?: string;
  onSmartSkin?: () => void;
}

class SkinSwitcher extends React.PureComponent<Props> {
  public static defaultProps: Partial<Props> = {
    smartSkin: '',
  };

  public onClickFunction = (e: React.MouseEvent<HTMLButtonElement | HTMLDivElement>, skin: LayoutSkin): void => {
    e.preventDefault();
    localStorage.setItem('sm-skin', skin.name);
    return this.props.onSmartSkin?.bind(this, skin)();
  };

  public render(): JSX.Element {
    return (
      <div className="visual-options-form">
        <form>
          <h1>Choose your Skin</h1>
          <h3 className="margin-top -10 semi-bold margin-bottom-5">Skins</h3>

          <section id="smart-styles">
            {config.skins.map((skin: LayoutSkin) => {
              const check: React.ReactNode = this.props.smartSkin === skin.name ? <i className="fa fa-check fa-fw" /> : '';
              const beta: React.ReactNode = skin.beta ? <sup>beta</sup> : '';
              return (
                <span key={skin.label} className="pull-left mr-1">
                  <div onClick={(e: React.MouseEvent<HTMLDivElement>): void => { this.onClickFunction(e, skin); }}>
                    <img
                      alt="preview"
                      className="preview-img"
                      src={`assets/img/preview_${skin.label.toLowerCase()}.png`}
                    />
                  </div>
                  <button
                    type="button"
                    onClick={(e: React.MouseEvent<HTMLButtonElement>): void => {
                      this.onClickFunction(e, skin);
                    }}
                    className={skin.class}
                    style={({ ...skin.style, marginBottom: '16px' })}
                    key={skin.name}
                  >
                    {check} {skin.label} {beta}
                  </button>
                </span>
              );
            })}
          </section>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state: any): Props => state.layout;

/**
 * Function to dispatch the actions to props
 *
 * @param dispatch the action to dispacht
 * @returns action maps with the possibilities
 */
function mapDispatchToProps(dispatch: any): any {
  return bindActionCreators(LayoutActions as any as ActionCreatorsMapObject, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SkinSwitcher);
